import { fuzzySearch } from '@libs/ui/ds'
import type { FilterFn } from '@tanstack/react-table'

export const tableFilterAdapter: FilterFn<any> = (row, columnId, value) => {
  return fuzzySearch({
    search: value,
    options: [row.getValue(columnId)]
  })
}
